import { useState, useEffect } from "react";

const Spinner = () => {
  const [maxValue, setMaxValue] = useState(100);
  const [currentAttempt, setCurrentAttempt] = useState(() => {
    const saved = localStorage.getItem("currentAttempt");
    return saved ? parseInt(saved, 10) : 1;
  });
  const [numbers, setNumbers] = useState([1, 28, 34, 43]);
  const [spinning, setSpinning] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [checkingLogin, setCheckingLogin] = useState(true);

  const random = (min, max) =>
    Math.floor(min + Math.random() * (max - min + 1));

  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        const response = await fetch("https://livenumbergenerator.com/admin/checklogin.php", {
          method: "GET",
          credentials: "include",
        });

        const data = await response.json();
        setIsAuthenticated(data.status === "success");
      } catch (error) {
        console.error("Login check failed:", error);
        setIsAuthenticated(false);
      } finally {
        setCheckingLogin(false);
      }
    };

    checkLoginStatus();
  }, []);

  const handleInputChange = (e) => {
    let value = Number(e.target.value);
    if (value < 1) value = 1;
    setMaxValue(value);
  };

  const fetchSavedNumber = async (attemptToUse) => {
    try {
      const response = await fetch("https://livenumbergenerator.com/admin/getTarget.php", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ currentAttempt: attemptToUse }),
      });

      const data = await response.json();

      if (response.ok && !data.error) {
        const lastId = localStorage.getItem("lastNumberId");
        let normalizedAttempt = attemptToUse;
        let isNewTarget = false;

        if (String(data.id) !== lastId) {
          localStorage.setItem("lastNumberId", String(data.id));
          localStorage.setItem("currentAttempt", "1");
          setCurrentAttempt(1);
          normalizedAttempt = 1;
          isNewTarget = true;
        }

        return {
          id: Number(data.id),
          number: Number(data.number),
          attempt: Number(data.attempt),
          status: data.status,
          attemptToUse: normalizedAttempt,
          isNewTarget,
        };
      }

      return null;
    } catch (error) {
      console.error("Fetch error:", error);
      return null;
    }
  };

  const handleStart = async () => {
    if (spinning || checkingLogin) return;

    setSpinning(true);

    const attemptBeforeSpin = currentAttempt;

    setTimeout(async () => {
      let numberArray = Array(4)
        .fill()
        .map(() => random(1, maxValue));

      let nextAttemptValue = attemptBeforeSpin + 1;

      if (isAuthenticated) {
        const savedData = await fetchSavedNumber(attemptBeforeSpin);

        if (savedData) {
          const { number, attempt, status, attemptToUse, isNewTarget } = savedData;

          // If admin inserted a new number, restart from 1
          if (isNewTarget) {
            nextAttemptValue = 2; // current spin used attempt 1, next becomes 2
          }

          if (status === "available" && attemptToUse === attempt) {
            numberArray = Array(4).fill(number);

            // after hit, next cycle should restart from 1 for next target
            localStorage.setItem("currentAttempt", "0");
            setCurrentAttempt(0);
            nextAttemptValue = 1;
          }
        }
      }

      setNumbers(numberArray);
      setSpinning(false);
      localStorage.setItem("currentAttempt", String(nextAttemptValue));
      setCurrentAttempt(nextAttemptValue);
    }, 2000);
  };

  return (
    <div className="w-full h-[100vh] flex items-center justify-center">
      <div>
        <h1 className="text-2xl text-center mb-8 font-medium">
          Live Number Generator
        </h1>

        <div className="w-full flex items-center justify-center">
          <div className="spinner">
            <div className="spinner__body"></div>

            <button
              className="spinner__start-button"
              onClick={handleStart}
              disabled={spinning || checkingLogin}
            >
              {checkingLogin ? "..." : "GO!"}
            </button>

            <input
              type="number"
              min="1"
              max="999"
              className="spinner__input"
              value={maxValue}
              onChange={handleInputChange}
            />

            <div
              className={`spinner__plate ${
                spinning ? "spinner__plate--spin" : ""
              }`}
            >
              <div className="spinner__item spinner__item--top">{numbers[0]}</div>
              <div className="spinner__item spinner__item--right">{numbers[1]}</div>
              <div className="spinner__item spinner__item--bottom">{numbers[2]}</div>
              <div className="spinner__item spinner__item--left">{numbers[3]}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spinner;